import React, { useContext, useState } from "react";
import "../../CSS/components.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../App"; // Import the AuthContext
import { Button, TextInput } from "../indexComponents";

function LoginForm() {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const navigate = useNavigate();

  // Add the following line to access the setIsAuthenticated function from the context
  const { setIsAuthenticated, redirectLink } = useContext(AuthContext);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      console.log("data :", data);

      if (!response.ok) {
        throw new Error("Failed to add event");
      }

      console.log("Logged in:", data);
      if (data.token) {
        localStorage.setItem("token", data.token);
        setIsAuthenticated(true);
        navigate(redirectLink);
      } else {
        console.error("Error:", data);
        console.log("1");
      }
    } catch (error) {
      console.error("Error:", error);
      console.log("4");
    }
  };

  return (
    <div className="LoginForm">
      <form onSubmit={handleSubmit}>
        <h1>Se Connecter</h1>
        <TextInput
          labelText="Nom d'utilisateur"
          name="username"
          type="text"
          placeholder=""
          value={formData.username}
          onChange={handleChange}
        />
        <TextInput
          labelText="Mot de passe"
          name="password"
          type="password"
          placeholder=""
          value={formData.password}
          onChange={handleChange}
        />
        {/* <Button route="" divClass="btn-login" type="submit" text="Se Connecter"></Button> */}
        <button type="submit">Se Connecter</button>
      </form>
      <div>
        <h2>Pas de compte ?</h2>
        <Button
          route="/signup"
          divClass="btn-login"
          type=""
          text="Créer un compte"
        ></Button>
      </div>
    </div>
  );
}

export default LoginForm;
